import React, { Component } from 'react'

export default class SectionFooter extends Component {
  render() {
    const { children, ...props } = this.props;
    return (
      <div className="grid mt-8" {...props}>
        {children}
      </div>
    )
  }
}
